<!-- <div *ngIf="!Flag; else seo" class="row"> -->
    <!-- <div class="row" *ngIf="SettingsView === 'R'"> -->
    <!-- <div class="col-md-7">
        <ng-template [ngTemplateOutlet]="PageSettings"></ng-template>
    </div> -->
    
    <div class="row"  *ngIf="seo">
        <div class="col-md-8">
            <form [formGroup]="SEOForm" #seoForm="ngForm">
                <div class="row">
                    <div class="col-md-12">
                        <div class="cDefault"
                            [ngClass]="{'cErorr': frmSeo.SEOPageTitle.invalid && (frmSeo.SEOPageTitle.touched || seoForm.submitted),'cSuccess': frmSeo.SEOPageTitle.valid && frmSeo.SEOPageTitle.dirty}">
                            <h5>SEO Page Title</h5>
                            <input type="text" formControlName="SEOPageTitle" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="cDefault"
                            [ngClass]="{'cErorr': frmSeo.SEOKeywords.invalid && (frmSeo.SEOKeywords.touched || seoForm.submitted),'cSuccess': frmSeo.SEOKeywords.valid && frmSeo.SEOKeywords.dirty}">
                            <h5>SEO Keywords</h5>
                            <input type="text" formControlName="SEOKeywords" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="cDefault"
                            [ngClass]="{'cErorr': frmSeo.SEOMetaDescription.invalid && (frmSeo.SEOMetaDescription.touched || seoForm.submitted),'cSuccess': frmSeo.SEOMetaDescription.valid && frmSeo.SEOMetaDescription.dirty}">
                            <h5>SEO Meta Description(Upto 500 Char)</h5>
                            <textarea formControlName="SEOMetaDescription" maxlength="500"></textarea>
                            <input type="hidden" formControlName="SettingID" />
                        </div>
                    </div>
                </div>
                <div class="cDivAction">
                    <button *ngIf="!FormSubmitted" (click)="submitToDataBase()" class="cButtonSubmit"></button>
                    <ManikButtonLoader *ngIf="FormSubmitted"></ManikButtonLoader>
                </div>
            </form>
        </div>
        
    </div>
    <!-- </div>-->
    <div class="row" *ngIf="seting">
        <div class="col-md-10">
            <form  [formGroup]="microSiteForm" #sFrm="ngForm">
                <mat-horizontal-stepper #stepper>
                    <mat-step>
                        <ng-template matStepLabel>Zero</ng-template>
                        <div class="row">
                            <h4 class="cManik-h4">Site Settings</h4>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="cMatdd_main">
                                    <h5>Select Template</h5>
                                    <mat-select (selectionChange)="onSelectLayout($event)" formControlName="MicrositeID"
                                        placeholder="Choose an option">
                                        <mat-option *ngFor="let l of template" [value]="l.DataValue">
                                            {{l.DataText}}
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cMatdd_main">
                                    <h5>Site Width</h5>
                                    <mat-select formControlName="BodyWidth" placeholder="Choose an option">
                                        <mat-option *ngFor="let item of SiteWidthList" [value]="item.DataValue">
                                            {{item.DataText}}</mat-option>
                                    </mat-select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>Main Font Color</h5>
                                    <input type="color" formControlName="SiteTextColor" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <h4 class="cManik-h4">Font Selection</h4>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="cMatdd_main">
                                    <h5>Primary</h5>
                                    <mat-select formControlName="FontID1" placeholder="Select an option">
                                        <mat-option *ngFor="let ff of fontFamily" [value]="ff.FontID">
                                            <span [style.font-family]="ff.FontStr">{{ff.FontName}}</span>
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cMatdd_main">
                                    <h5>Secondary</h5>
                                    <mat-select formControlName="FontID2" placeholder="Select an option">
                                        <mat-option *ngFor="let ff of fontFamily" [value]="ff.FontID">
                                            {{ff.FontName}}
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cMatdd_main">
                                    <h5>Tertiary</h5>
                                    <mat-select formControlName="FontID3" placeholder="Select an option">
                                        <mat-option *ngFor="let ff of fontFamily" [value]="ff.FontID">
                                            {{ff.FontName}}
                                        </mat-option>
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <h4 class="cManik-h4">Paragraph Settings</h4>
                        </div>
                       
                        <div class="row">
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>Para Text Color</h5>
                                    <input type="color" formControlName="ParaTextColor" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>Para BG Color</h5>
                                    <input type="color" formControlName="ParaTextBGColor" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>Para Text Size</h5>
                                    <input type="number" (keypress)="manikInteger($event)" formControlName="ParaTextSize" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <h5 class="cManik-h5">Secondary (commonly used)</h5>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>Header Text Color</h5>
                                    <input type="color" formControlName="ParaSecondaryHdrTextColor" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>Header BG Color</h5>
                                    <input type="color" formControlName="ParaSecondaryHdrBGColor" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>Para Text Color</h5>
                                    <input type="color" formControlName="ParaSecondaryTextColor" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <h5 class="cManik-h5">Tertiary (rarely used)</h5>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>Header Text Color</h5>
                                    <input type="color" formControlName="ParaTertiaryHdrTextColor" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>Header BG Color</h5>
                                    <input type="color" formControlName="ParaTertiaryHdrBGColor" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>Para Text Color</h5>
                                    <input type="color" formControlName="ParaTertiaryTextColor" />
                                </div>
                            </div>
                        </div>
                    </mat-step>
                    <mat-step>
                        <ng-template matStepLabel>More</ng-template>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="cDefault">
                                    <h5>Default Icon Color</h5>
                                    <input type="color" formControlName="DefaultIconColor" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="cDefault">
                                    <h5>Default Icon BG Color</h5>
                                    <input type="color" formControlName="DefaultIconBG" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="cDefault">
                                    <h5>Default Button Text Color</h5>
                                    <input type="color" formControlName="DefaultButtonTextColor" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="cDefault">
                                    <h5>Default Button BG Color</h5>
                                    <input type="color" formControlName="DefaultButtonBG" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <h4 class="cManik-h4">Set Effects</h4>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="cMatdd_main">
                                    <h5>Menu</h5>
                                    <mat-select [(ngModel)]="MSModel.MDEffectID" ngDefaultControl placeholder="Choose an option"
                                        [ngModelOptions]="{standalone: true}">
                                        <mat-option *ngFor="let item of MenuDesignerEffects" [value]="item.DataValue">
                                            {{item.DataText}}</mat-option>
                                    </mat-select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cMatdd_main">
                                    <h5>Slider</h5>
                                    <mat-select [(ngModel)]="MSModel.SDEffectID" ngDefaultControl placeholder="Choose an option"
                                        [ngModelOptions]="{standalone: true}">
                                        <mat-option *ngFor="let item of SliderDesignerEffects" [value]="item.DataValue">
                                            {{item.DataText}}</mat-option>
                                    </mat-select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cMatdd_main">
                                    <h5>Header</h5>
                                    <mat-select [(ngModel)]="MSModel.HDEffectID" ngDefaultControl placeholder="Choose an option"
                                        [ngModelOptions]="{standalone: true}">
                                        <mat-option *ngFor="let item of HeaderDesignerEffects" [value]="item.DataValue">
                                            {{item.DataText}}</mat-option>
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="cMatdd_main">
                                    <h5>GoTo Top</h5>
                                    <mat-select [(ngModel)]="MSModel.GoToTopEffectID" ngDefaultControl placeholder="Choose an option"
                                        [ngModelOptions]="{standalone: true}">
                                        <mat-option *ngFor="let item of GoToTopDesignerEffects" [value]="item.DataValue">
                                            {{item.DataText}}</mat-option>
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                    </mat-step>
                    <mat-step>
                        <ng-template matStepLabel>Advanced</ng-template>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="cDefault">
                                    <h5>Does this site use Arabic (RTL) text?</h5>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="cDefault">
                                    <h5> No <mat-slide-toggle [(ngModel)]="IsRTL" ngDefaultControl [ngModelOptions]="{standalone: true}">
                                        </mat-slide-toggle> Yes</h5>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>H1 Text Color</h5>
                                    <input type="color" formControlName="H1TextColor" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>H1 Text BGColor</h5>
                                    <input type="color" formControlName="H1TextBGColor" />
                                    <a href="javascript:void(0);" (click)="OnClickBgColor('H1TextBGColor')"></a>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>H1 Text Size</h5>
                                    <input type="number" (keypress)="manikInteger($event)" formControlName="H1TextSize" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>H2 Text Color</h5>
                                    <input type="color" formControlName="H2TextColor" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>H2 Text BGColor</h5>
                                    <input type="color" formControlName="H2TextBGColor" />
                                    <a href="javascript:void(0);" (click)="OnClickBgColor('H2TextBGColor')"></a>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>H2 Text Size</h5>
                                    <input type="number" (keypress)="manikInteger($event)" formControlName="H2TextSize" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>H3 Text Color</h5>
                                    <input type="color" formControlName="H3TextColor" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>H3 Text BGColor</h5>
                                    <input type="color" formControlName="H3TextBGColor" />
                                    <a href="javascript:void(0);" (click)="OnClickBgColor('H3TextBGColor')"></a>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>H3 Text Size</h5>
                                    <input type="number" (keypress)="manikInteger($event)" formControlName="H3TextSize" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>H4 Text Color</h5>
                                    <input type="color" formControlName="H4TextColor" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>H4 Text BGColor</h5>
                                    <input type="color" formControlName="H4TextBGColor" />
                                    <a href="javascript:void(0);" (click)="OnClickBgColor('H4TextBGColor')"></a>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>H4 Text Size</h5>
                                    <input type="number" (keypress)="manikInteger($event)" formControlName="H4TextSize" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>Menu Text Color</h5>
                                    <input type="color" formControlName="MenuTextColor" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>Menu Text BGColor</h5>
                                    <input type="color" formControlName="MenuTextBGColor" />
                                    <a href="javascript:void(0);" (click)="OnClickBgColor('MenuTextBGColor')"></a>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>Menu Text Size</h5>
                                    <input type="number" (keypress)="manikInteger($event)" formControlName="MenuTextSize" />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>Biz Title Text Color</h5>
                                    <input type="color" formControlName="BizTitleTextColor" />
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>Biz Title Text BGColor</h5>
                                    <input type="color" formControlName="BizTitleTextBGColor" />
                                    <a href="javascript:void(0);"
                                        (click)="OnClickBgColor('BizTitleTextBGColor')"></a>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="cDefault">
                                    <h5>Biz Title Text Size</h5>
                                    <input type="number" (keypress)="manikInteger($event)" formControlName="BizTitleTextSize" />
                                </div>
                            </div>
                        </div>
                    </mat-step>
                </mat-horizontal-stepper>
                <div class="cDivAction">
                    <button *ngIf="!FormSubmitted" (click)="submitToDataBase()" class="cButtonSubmit"></button>
                    <ManikButtonLoader *ngIf="FormSubmitted"></ManikButtonLoader>
                </div>
                <input type="hidden" formControlName="SettingID" />
            </form>
        </div>
       
    </div>
    <div class="row" *ngIf="bak">
        <h4 class="cManik-h4">Site Background</h4>
        <image-handler *ngIf="PopulateSmartMedia" [ImageData]="ImageData"></image-handler>
    </div> 
<!-- </div> -->
